import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { NurikabePresence } from "./Player";
import { registerNurikabeTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  NurikabeDefinition,
  NurikabeProgress,
  NurikabeSolution,
  NurikabeSubmission,
} from "./types";

registerNurikabeTranslations(i18n);

export const nurikabeModule: PuzzleTypeModule<
  NurikabeDefinition,
  NurikabeSubmission,
  NurikabeProgress,
  NurikabeSolution,
  NurikabePresence
> = {
  key: "nurikabe",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
